import { Sidebar } from "@/components/blocks/SideBar";
import { FC } from "react";
import { useLocalization } from "@/data/Localization";
import { sidebarAppBarContainerSXP, sidebarAppBarContentSXP, sidebarAccordionSummarySXP } from "../../FacetNavigation/styles/sidebar";
import { FacetNavigationItemChange } from "@/components/content/HelloRetailFacetNavigation/parts/ItemChange";
import { FacetNavigationPriceChange } from "@/components/content/HelloRetailFacetNavigation/parts/PriceChange";
import { FacetNavigationCategoryFacet } from "./CategoryFacet";

export const FacetNavigationList:FC = () => {

    const productFilterNLS = useLocalization('ProductFilter');
    
    return (
        <Sidebar
            title={productFilterNLS.Labels.filterBy.t()}
            scrollable={true}
            {...{
                sidebarAppBarContainerSXP,
                sidebarAppBarContentSXP,
                sidebarAccordionSummarySXP
            }}
        >
            <FacetNavigationCategoryFacet />
            <FacetNavigationPriceChange />
            <FacetNavigationItemChange />
        </Sidebar>
    )
}